module.exports = __webpack_public_path__ + "img/Image_logo_11.054758f1.jpg";